// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2254e604","239":"e62a1096","453":"b82168a1","455":"8172f859"}[chunkId] + ".chunk.js";
};